import styled from 'styled-components';
import { Media } from 'enums';

export const SearchCategory = styled.div`
  width: 100%;
  margin-bottom: 30px;

  @media ${Media.notebook} {
    margin-top: 20px;
    margin-bottom: 0px;
  }
`;

export const WrapperRecent = styled.div`
  display: flex;
`;

export const ItemBox = styled.div`
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  row-gap: 16px;

  @media ${Media.notebook} {
    row-gap: 10px;
    margin-top: 10px;
  }
`;
